<template>
  <div>
    <steps-order
      :step=1
    ></steps-order>

    <section class="invoice">
      <!-- title row -->
      <div class="row">
        <div class="col-xs-12">
          <h2 class="page-header">
            <i class="fa fa-shopping-cart"></i> Votre panier
          </h2>
        </div>
      </div>
      <div class="row" v-if="cartIsEmpty()">
        <div class="col-xs-12 table-responsive">
          <p class="text-center">Votre panier est vide.</p>
        </div>
      </div>
      <!-- Table row -->
      <div class="row" v-if="!cartIsEmpty()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-responsive" v-if="getCart">
            <thead>
            <tr>
              <th>Produit</th>
              <th>Quantité</th>
              <th><span class="pull-right">Prix</span></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item,key) in getCart">
              <tr class="products-list product-list-in-box item" v-for="(obj,id) in item">
                <template v-if="key=='licence_club'">
                  <td class="">
                    <div class="product-img">
                      <img src="../../assets/img/logos/logoProduct.jpg" alt="Product Image"
                           style="width: 150px;height: auto;border-radius: 4px;box-shadow: 0 1px 3px rgba(0,0,0,.15);">
                    </div>
                    <div class="product-info">
                                        <span class="product-title">
                                          {{ obj.club }}
                                        </span>
                      <span class="product-description">
                                       Licence annuelle ABFT <br>
                                       Licence club <u>{{ currentYear() }}</u>
                                        </span>
                    </div>
                  </td>
                  <td>
                    <select v-model="obj.quantity" name="" >
                      <option value="1">1</option>
                      <!--                      <option value="2">2</option>-->
                      <!--                      <option value="3">3</option>-->
                      <!--                      <option value="4">4</option>-->
                      <!--                      <option value="5">5</option>-->
                      <!--                      <option value="null">-&#45;&#45;</option>-->
                      <!--                      <option value="5">Supprimer</option>-->
                    </select>
                    <i class="fa fa-trash"
                       style="margin-left:8px;cursor: pointer"
                       @click="removeFromCart({id:id,type:'licence_club'})"
                    ></i>
                  </td>
                  <td class="pull-right">
                    <div class="price">{{ obj.price.toFixed(2).replace(".", ",") }}€</div>
                  </td>
                </template>

                <template v-if="key=='licence_renew'">
                  <td class="">
                    <div class="product-img">
                      <img src="../../assets/img/logos/logoProduct.jpg" alt="Product Image"
                           style="width: 150px;height: auto;border-radius: 4px;box-shadow: 0 1px 3px rgba(0,0,0,.15);">
                    </div>
                    <div class="product-info">
                                        <span class="product-title">
                                          {{ obj.member.fullName }}
                                        </span>
                      <span class="product-description">
                                       Renouvellement <br>
                                       Du {{ obj.member.dateDebutIfSelected }} au {{ obj.member.dateFinIfSelected }}
                                        </span>
                    </div>
                  </td>
                  <td>
                    <select v-model="obj.quantity" name="" id="">
                      <option value="1">1</option>
                      <!--                      <option value="2">2</option>-->
                      <!--                      <option value="3">3</option>-->
                      <!--                      <option value="4">4</option>-->
                      <!--                      <option value="5">5</option>-->
                      <!--                      <option value="null">-&#45;&#45;</option>-->
                      <!--                      <option value="5">Supprimer</option>-->
                    </select>
                    <i class="fa fa-trash"
                       style="margin-left:8px;cursor: pointer"
                       @click="removeFromCart({id:id,type:'licence_renew'})"
                    ></i>
                  </td>
                  <td class="pull-right">
                    <div class="price">{{ obj.price.toFixed(2).replace(".", ",") }}€</div>
                  </td>
                </template>
              </tr>
            </template>
            <tr class="products-list product-list-in-box item">
              <td colspan="2">
                            <span class="product-title pull-right" style="font-weight:normal;">
                                Sous-total :
                            </span>
              </td>
              <td>
                <span class="price pull-right" style="font-weight:normal; font-size:12px">{{ getTotalFromCart().toFixed(2).replace(".", ",") }}€</span>
              </td>
            </tr>
            <tr class="products-list product-list-in-box item">
              <td colspan="2">
                            <span class="product-title pull-right" style="font-weight:normal;">
                                Frais de livraison :
                            </span>
              </td>
              <td>
                <span class="price pull-right" style="font-weight:normal; font-size:12px">0,00€</span>
              </td>
            </tr>
            <tr class="products-list product-list-in-box item">
              <td colspan="2">
                            <span class="product-title pull-right">
                                Montant total :
                            </span>
              </td>
              <td>
                <span class="price pull-right">{{ getTotalFromCart().toFixed(2).replace(".", ",") }}€</span>
              </td>

            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row no-print" v-if="!cartIsEmpty()">
        <div class="col-xs-12">
          <a :disabled="cartIsEmpty()"
             @click.prevent="goToLivraison" type="button" class="btn btn-primary pull-right">
            <i class="fa fa-address-book"></i>
            Définir mon adresse de livraison
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import {mapGetters, mapActions} from 'vuex'
import stepsOrder from '../stepsOrder'
import moment from 'moment/moment'
let _ = require('lodash')
export default {
  data() {
    return {}
  },
  methods: {
    ...mapActions({
      setStepOrder: 'setStepOrder',
      removeFromCart: "removeFromCart"
    }),
    logout: function () {
      Auth.logout();
    },
    goToLivraison: function () {
      // this.setModePayement(this.modePayement)
      if (this.cartIsEmpty())
        return
      this.setStepOrder({step: 'step1', value: true})
      this.$router.push({name: 'Livraison'})
    },
    cartIsEmpty: function () {
      let total = 0
      _.map(this.getCart, (item, index) => {
        switch (index) {
          case 'licence_renew':
            _.map(item, (obj) => {
              total++
            })
            break
          case 'licence_club':
            _.map(item, (obj) => {
              total++
            })
            break
        }
      })
      return total == 0 ? true : false
    },
    currentYear: function () {
      return moment().year();
    },
    getTotalFromCart: function () {
      let total = 0
      _.map(this.getCart, (item, index) => {
        switch (index) {
          case 'licence_renew':
            _.map(item, (obj) => {
              total += obj.price
            })
            break
          case 'licence_club':
            _.map(item, (obj) => {
              total += obj.price
            })
            break
        }
      })
      return total
    }
  },
  components: {
    stepsOrder
  },
  computed: {
    ...mapGetters({
      getCart: 'getCart'
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Order/Cart.vue